// src/components/Header.js
import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../../css/Header.css'
import logo from './transparentLogo.png';
import Utils from "../../utils/Utils";
import {useAuth} from "../../auth/AuthContext";
import {Link} from "react-router-dom";

const BASE_URL = "https://iacdc.tau.ac.il/files/";

function Header() {
    const [suberName, setSuberName] = useState([]);
    const [showDataAccess, setShowDataAccess] = useState(false);
    const [showDatasets, setShowDatasets] = useState(false);

    const { user } = useAuth();

    useEffect(() => {
        const loadDirs = async () => {
            try {
                const resp = await Utils.getAllDirs();
                const response = resp.data.items || [];

                const dirs = response
                    .filter((item) => item.name && item.path)
                    .map((item) => ({
                        name: item.name,
                        path: item.path,
                    }));

                setSuberName(dirs);
            } catch (err) {
                console.error("Failed to load header datasets:", err);
            }
        };

        loadDirs();
        }, []);

    const closeAllDropdowns = () => {
        setShowDataAccess(false);
        setShowDatasets(false);
    };

    return (
        <header>
            <Navbar fixed="top" bg="light" expand="lg" className="main-navbar">
                <Container>
                    <Navbar.Brand href="/">
                        <img
                            src={logo}
                            alt={"Isreali Atmpspheric and Climatic Data Center Logo"}
                            className={"header-logo"}
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto" justify variant="tabs" style={{width: '100%'}}>
                            <Nav.Link as={Link} to={"/"} onClick={closeAllDropdowns}>
                                Home
                            </Nav.Link>
                            <Nav.Link as={Link} to="/about" onClick={closeAllDropdowns}>
                                About
                            </Nav.Link>
                            <Nav.Link as={Link} to="/categories" onClick={closeAllDropdowns}>
                                Data by Category
                            </Nav.Link>
                            <NavDropdown
                                id="data-access-dropdown"
                                title="Data Access"
                                show={showDataAccess}
                                onMouseEnter={() => setShowDataAccess(true)}
                                onMouseLeave={() => {
                                    setShowDataAccess(false);
                                    setShowDatasets(false);
                                }}
                            >
                                <NavDropdown
                                    id="datasets-dropdown"
                                    title="Datasets"
                                    drop="end"
                                    show={showDatasets}
                                    onMouseEnter={() => setShowDatasets(true)}
                                    onMouseLeave={() => setShowDatasets(false)}
                                >
                                    {suberName.map((x) => (
                                        <NavDropdown.Item
                                            key={x.path}
                                            as={Link}
                                            to={`/data/${x.path}`}
                                            onClick={closeAllDropdowns}
                                        >
                                            {x.name}
                                        </NavDropdown.Item>
                                    ))}
                                </NavDropdown>

                                <NavDropdown.Divider />

                                <NavDropdown.Item
                                    as={Link}
                                    to="/batch-downloads"
                                    onClick={closeAllDropdowns}
                                >
                                    Download Data in <br /> Batch from the IACDC
                                </NavDropdown.Item>

                                <NavDropdown.Divider />

                                <NavDropdown.Item
                                    as={Link}
                                    to="/research-repository"
                                    onClick={closeAllDropdowns}
                                >
                                    Research Data Repository
                                </NavDropdown.Item>

                                <NavDropdown.Divider />

                                <NavDropdown.Item
                                    as={Link}
                                    to="/online-resources"
                                    onClick={closeAllDropdowns}
                                >
                                    Other Online Research
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link
                                as={Link} to="/contact"
                                onClick={closeAllDropdowns}
                            >
                                Contact
                            </Nav.Link>

                            {user?.is_admin ? (
                                <Nav.Link
                                    as={Link}
                                    to="/admin"
                                    onClick={closeAllDropdowns}
                                >
                                    Dashboard
                                </Nav.Link>
                            ) : (
                                <Nav.Link
                                    as={Link}
                                    to="/login"
                                    onClick={closeAllDropdowns}
                                >
                                    Login
                                </Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;


/*

const [showSub, setShowSub] = useState(false);
    const showSubDropdown = (e)=>{
        setShow(!show);
    }
    const hideSubDropdown = e => {
        setShow(false);
    }
 */